// components/HomePage/components/Coach/CoachContainer.jsx
import React, { useEffect, useState, useCallback } from "react";
import { progressService } from "../../../../services/progressService";
import { coachRegistry } from "./index";
import { useModal } from "../../ModalContext";

const CoachContainer = ({
  userId,
  course,
  module,
  subsection,
  onProgressUpdate,
  actions,
  onToggleImmersive,
}) => {
  const [payload, setPayload] = useState({});
  const { openModal, closeModal } = useModal();

  /* ---------- Load existing progress ---------- */
  useEffect(() => {
    if (!subsection?.id) return;

    const fetchProgress = async () => {
      try {
        const progress = await progressService.getUserProgress(userId, subsection.id);
        const data = progress?.data?.payload || progress?.payload || {};
        setPayload(data);
        await progressService.updateUserState(userId, subsection.id);
      } catch (err) {
        console.error("Coach progress load failed:", err);
      }
    };

    fetchProgress();
  }, [userId, subsection?.id]);

  /* ---------- Exit immersive mode ---------- */
  useEffect(() => {
    onToggleImmersive?.(false);
  }, [onToggleImmersive]);

  /* ---------- Save progress ---------- */
  const saveProgress = useCallback(
    async (status, newPayload = {}) => {
      try {
        const updated = await progressService.saveProgress(
          userId,
          subsection.id,
          { type: "coach", payload: newPayload },
          status
        );
        onProgressUpdate?.(updated);
      } catch (err) {
        console.error("Coach progress save failed:", err);
      }
    },
    [userId, subsection?.id, onProgressUpdate]
  );

  /* ---------- Select the specific coach screen ---------- */
  const CoachScreen = coachRegistry[subsection.subsection_url] || null;

  if (!CoachScreen) {
    return <p className="text-[#6B7280] italic">No matching coach screen found.</p>;
  }

  /* ---------- Render the selected screen ---------- */
  return (
    <div className="w-full flex-1 min-h-0 overflow-y-auto">
      <h2 className="text-[28px] font-bold text-ink mb-8">{subsection.title}</h2>

      <div className="relative w-full rounded-xl overflow-hidden bg-white shadow-sm p-8">
        <CoachScreen
          subsection={subsection}
          userId={userId}
          payload={payload}
          saveProgress={saveProgress}
          openModal={openModal}
          closeModal={closeModal}
          actions={actions}
        />
      </div>
    </div>
  );
};

export default CoachContainer;
